import React, { createContext, useContext, useSyncExternalStore } from 'react'
import type { Services } from './services/types'
import type { StorageModules } from './storage/types'
import type { GlobalEvent } from './types/global-events'
import { EventEmitter } from '~common/utils/events'

const AppContext = createContext<AppContextType | null>(null)

export interface AppContextType {
    services: Services
    storageModules: StorageModules
    globalEvents?: EventEmitter<GlobalEvent>
}

export type AppProviderProps = React.PropsWithChildren<AppContextType>

export const AppProvider: React.FC<AppProviderProps> = ({
    services,
    storageModules,
    globalEvents,
    children,
}) => (
    <AppContext.Provider value={{ services, storageModules, globalEvents }}>
        {children}
    </AppContext.Provider>
)

export function useAppContext(): AppContextType {
    const context = useContext(AppContext)
    if (!context) {
        throw new Error('useAppContext must be used within a AppProvider')
    }
    return context
}
